// src/components/layouts/AdminLayout.tsx
import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Sidebar, Header } from "@/components/common";
import { Toaster } from "@/components/ui/sonner"

export default function AdminLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const location = useLocation();

    // Store the current path in localStorage when it changes
    useEffect(() => {
        // Don't store auth-related paths
        if (!location.pathname.startsWith('/auth')) {
            localStorage.setItem('lastVisitedPage', location.pathname);
        }
    }, [location.pathname]);

    return (
        <div className="flex h-screen overflow-hidden bg-slate-50 dark:bg-background">
            <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
            <div className="flex flex-col flex-1 overflow-hidden">
                <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
                <main className="flex-1 overflow-y-auto px-6 py-5">
                    <Outlet />
                </main>
            </div>
            <Toaster />
        </div>
    );
}